// Словарь синонимов для поиска
export const synonymsDictionary = {
  // Утеплители
  'утеплитель': ['минеральная вата', 'минвата', 'теплоизоляция', 'изоляция', 'мат ламельный'],
  'минеральная вата': ['утеплитель', 'минвата', 'теплоизоляция', 'изоляция', 'роквул'],
  'минвата': ['утеплитель', 'минеральная вата', 'теплоизоляция'],
  'теплоизоляция': ['утеплитель', 'минеральная вата', 'изоляция'],
  // 'роквул': ['утеплитель', 'минеральная вата', 'минвата'],
  // 'базальт': ['утеплитель', 'минеральная вата'],
  'баттс': ['утеплитель', 'плита'],
  'цилиндры': ['утеплитель', 'труба изоляция'],

  'профнастил': ['профлист', 'металлопрофиль'],
  'профлист': ['профнастил', 'металлопрофиль'],
  // 'металлопрофиль': ['профнастил', 'профлист'],

  'металлочерепица': ['металлическая черепица', 'кровля', 'черепица'],
  'черепица': ['металлочерепица', 'кровля'],
  'кровля': ['металлочерепица', 'кровельный', 'крыша'],
  'кровельный': ['кровля', 'крыша'],
  'крыша': ['кровля', 'кровельный'],

  'лист': ['плита', 'панель'],
  'плита': ['лист', 'панель'],
  'панель': ['лист', 'плита'],

  'осп': ['osb', 'осб', 'ориентированно-стружечная плита'],
  'osb': ['осп', 'осб', 'ориентированно-стружечная плита'],

  'гкл': ['гипсокартон', 'гипсовая плита'],
  'гипсокартон': ['гкл', 'гипсовая плита'],

  'пеноплекс': ['пенополистирол', 'эппс', 'xps', 'экструзия'],
  'пенополистирол': ['пеноплекс', 'эппс', 'xps'],
  'эппс': ['пеноплекс', 'пенополистирол', 'xps'],

  'фанера': ['фанерный лист', 'влагостойкая фанера'],

  'цемент': ['портландцемент', 'цементный'],
  'портландцемент': ['цемент'],

  'арматура': ['армирующий', 'стержень'],

  'блок': ['газоблок', 'пеноблок', 'строительный блок'],
  'газоблок': ['блок', 'газобетон'],
  'газобетон': ['газоблок', 'блок'],
  'пеноблок': ['блок'],

  'мембрана': ['пленка', 'пароизоляция', 'гидроизоляция', 'изоспан', 'ветрозащита'],
  'пленка': ['мембрана', 'пароизоляция', 'изоспан'],
  'пароизоляция': ['мембрана', 'пленка', 'изоспан'],
  'гидроизоляция': ['мембрана', 'пленка', 'изоспан'],
  'изоспан': ['мембрана', 'пленка', 'пароизоляция'],
  'ветрозащита': ['мембрана', 'пленка'],

  // Кровельные элементы
  'планка': ['доборный элемент', 'комплектующие'],
  'штакетник': ['забор', 'евроштакетник', 'металлический штакетник'],
  'евроштакетник': ['штакетник', 'забор'],

  // ЖБИ
  'кольцо': ['кольцо жби', 'колодец', 'кс'],
  'плита перекрытия': ['плита жби', 'перекрытие', 'пк', 'пб'],
  'блок фбс': ['фбс', 'фундаментный блок', 'стеновой блок'],
  'перемычка': ['перемычка жби', 'железобетонная перемычка'],

  // Пиломатериалы
  'доска': ['пиломатериал', 'обрезная доска'],
  'брус': ['пиломатериал', 'брусок'],
  'вагонка': ['обшивка', 'облицовка'],
  'имитация бруса': ['имитация', 'фальш-брус'],

  // Крепеж
  'саморез': ['шуруп', 'винт', 'крепеж'],
  'гвоздь': ['крепеж', 'гвозди'],
  'болт': ['крепеж', 'метиз'],
  'кляммер': ['крепеж', 'кляймер', 'кровельный крепеж'],

  // Бренды (вариации написания)
  'grand line': ['грандлайн', 'гранд лайн', 'гранд-лайн', 'grandline', 'gl'],
  'грандлайн': ['grand line', 'гранд лайн'],
  'egger': ['еггер', 'эггер', 'егер'],
  'еггер': ['egger', 'эггер'],
  'vortex': ['вортекс', 'вортэкс'],
  'вортекс': ['vortex', 'вортэкс'],
  'rockwool': ['роквул', 'роквол', 'роквулл', 'рокволл'],
  'роквул': ['rockwool', 'роквол'],
  'технониколь': ['technonicol', 'тн', 'технониколь'],
  'anderep': ['андерэп', 'андереп'],
  'foramina': ['фораминá', 'форамина'],
  'тисма': ['tisma', 'тисма'],

  // Цвета и RAL коды
  'ral 7004': ['сигнальный серый', 'серый 7004', 'рал 7004'],
  'сигнальный серый': ['ral 7004', 'рал 7004'],
  'ral 7024': ['мокрый асфальт', 'серый 7024', 'рал 7024', 'темно-серый'],
  'мокрый асфальт': ['ral 7024', 'рал 7024'],
  'ral 9005': ['черный', 'чёрный', 'рал 9005'],
  'черный': ['ral 9005', 'чёрный', 'рал 9005'],
  'ral 6005': ['зеленый', 'зелёный', 'зеленый мох', 'рал 6005'],
  'зеленый': ['ral 6005', 'зелёный', 'рал 6005'],
  'ral 1015': ['слоновая кость', 'бежевый', 'светлый', 'рал 1015'],
  'слоновая кость': ['ral 1015', 'рал 1015'],
  'ral 3009': ['красный', 'красный оксид', 'рал 3009'],
  'ral 8017': ['коричневый', 'шоколадный', 'рал 8017'],

  // Террасная доска и ДПК
  'дпк': ['древесно-полимерный композит', 'террасная доска', 'композитная доска'],
  'террасная доска': ['дпк', 'доска террасная', 'декинг'],
  'декинг': ['террасная доска', 'дпк'],
  'венге': ['венге', 'wenge', 'темно-коричневый'],
  'балясина': ['балясина', 'балюстрада'],
  'перила': ['перила', 'ограждение', 'поручень'],

  // Водосточные системы
  'желоб': ['водосточный желоб', 'лоток'],
  'водосток': ['водосточная система', 'желоб', 'труба водосточная'],
  'воронка': ['воронка водосточная', 'водоприемник'],
  'колено': ['колено трубы', 'отвод', 'угол трубы'],
  'заглушка': ['заглушка желоба', 'торцевая заглушка'],
  'кронштейн': ['держатель', 'крепление', 'крюк'],
  'крепление': ['кронштейн'],

  // Кровельные материалы расширенные
  'фальц': ['фальцевая кровля', 'кликфальц', 'двойной стоячий фальц'],
  'кликфальц': ['фальц', 'click falz', 'фальцевая кровля'],
  'экобрус': ['эко брус', 'eco брус', 'сайдинг под брус'],
  'квадробрус': ['квадро брус', 'quadro брус', 'сайдинг'],
  'ондулин': ['еврошифер', 'ondulin', 'битумный лист'],
  'гибкая черепица': ['мягкая кровля', 'битумная черепица', 'шинглас'],

  // ЛДСП и пиломатериалы
  'лдсп': ['ламинированная плита', 'дсп ламинированная', 'мебельная плита'],
  'кромка': ['кромочная лента', 'меламиновая кромка', 'торцевая лента'],
  'мдф': ['mdf', 'древесноволокнистая плита'],
  'лхдф': ['lhdf', 'хдф'],
  'дуб': ['дуб', 'oak', 'дубовый'],
  'чарльстон': ['charleston', 'темно-коричневый'],

  // Изоляция расширенная
  'скандик': ['skandik', 'скандик', 'роквул скандик'],
  'лайт баттс': ['light batts', 'лайтбаттс', 'лайт-баттс'],
  'фасад баттс': ['facade batts', 'фасадбаттс'],
  'изолайф': ['isolife', 'изолайф', 'изоляция'],

  // Размеры (для лучшего поиска)
  '3м': ['3000мм', '3000', 'три метра', '3 метра', '3 м'],
  '4м': ['4000мм', '4000', 'четыре метра', '4 метра', '4 м'],
  '6м': ['6000мм', '6000', 'шесть метров', '6 метров', '6 м'],
  '130мм': ['130', '13см', '130 мм'],
  '100мм': ['100', '10см', '100 мм'],
  '50мм': ['50', '5см', '50 мм'],

  // ⭐ Расширенные синонимы для лучшего понимания категорий
  // Различные типы утеплителей
  'каменная вата': ['утеплитель', 'минеральная вата', 'роквул', 'базальтовая вата'],
  'базальтовая вата': ['утеплитель', 'минеральная вата', 'роквул', 'каменная вата'],
  'стекловата': ['утеплитель', 'минеральная вата', 'изовер'],
  'эковата': ['утеплитель', 'целлюлозная изоляция'],

  // Различные виды изоляции
  'шумоизоляция': ['звукоизоляция', 'акустическая изоляция', 'изоляция'],
  'звукоизоляция': ['шумоизоляция', 'акустическая изоляция', 'изоляция'],
  'теплоизолятор': ['утеплитель', 'теплоизоляция'],
  'гидроизолятор': ['гидроизоляция', 'мембрана'],

  // Кровельные материалы (расширение)
  'кровельный лист': ['профнастил', 'профлист', 'металлопрофиль'],
  'металлический лист': ['профнастил', 'профлист', 'кровля'],
  'мет черепица': ['металлочерепица', 'кровля'],
  'металл черепица': ['металлочерепица', 'кровля'],

  // Плитные материалы
  'стружечная плита': ['осп', 'osb', 'ориентированно-стружечная плита'],
  'ориентированная плита': ['осп', 'osb'],
  'гипс': ['гкл', 'гипсокартон', 'гипсовая плита'],
  'гипсовый лист': ['гкл', 'гипсокартон'],

  // ЖБИ расширение
  'железобетон': ['жби', 'жби изделия', 'бетонные изделия'],
  'жби': ['железобетон', 'бетонные изделия', 'жби изделия'],
  'бетонные изделия': ['жби', 'железобетон'],
  'колодезные кольца': ['кольцо', 'кольцо жби', 'кс'],
  'кс кольцо': ['кольцо', 'колодезное кольцо', 'кольцо жби'],
  'фундаментные блоки': ['фбс', 'блок фбс', 'фундаментный блок'],
  'фбс блок': ['блок фбс', 'фундаментный блок', 'фундаментные блоки'],

  // Пиломатериалы расширение
  'пиломатериал': ['доска', 'брус', 'вагонка', 'дерево'],
  'древесина': ['доска', 'брус', 'пиломатериал'],
  'обрезная': ['доска', 'обрезная доска'],
  'необрезная': ['доска', 'необрезная доска'],
  'строганая доска': ['доска', 'пиломатериал'],
  'сухая доска': ['доска', 'пиломатериал'],

  // Сайдинг и фасадные материалы
  'сайдинг': ['обшивка', 'облицовка', 'фасадные панели'],
  'виниловый сайдинг': ['сайдинг', 'обшивка', 'фасад'],
  'металлсайдинг': ['сайдинг', 'металлический сайдинг', 'обшивка'],
  'фасадные панели': ['сайдинг', 'облицовка'],
  'облицовочные панели': ['сайдинг', 'фасадные панели'],

  // Крепёж расширение
  'метизы': ['крепеж', 'саморезы', 'гвозди', 'болты'],
  'крепёж': ['крепеж', 'метизы', 'саморезы'],
  'кровельные саморезы': ['саморез', 'крепеж', 'кровельный крепеж'],
  'шурупы': ['саморез', 'шуруп', 'крепеж'],

  // Отделочные материалы
  'половая доска': ['доска пола', 'половая', 'напольная доска'],
  'доска пола': ['половая доска', 'напольная доска'],
  'паркет': ['паркетная доска', 'напольное покрытие'],
  'ламинат': ['ламинированное покрытие', 'напольное покрытие'],

  // Изоляционные плёнки
  'паробарьер': ['пароизоляция', 'мембрана'],
  'гидробарьер': ['гидроизоляция', 'мембрана'],
  'ветробарьер': ['ветрозащита', 'мембрана'],
  'диффузионная мембрана': ['мембрана', 'гидроизоляция'],

  // Водостоки
  'водосточная труба': ['труба', 'водосток', 'водосточная система'],
  'водосточная система': ['водосток', 'желоб', 'воронка'],
  'водоотвод': ['водосток', 'водосточная система'],

  // Строительные смеси
  'раствор': ['цемент', 'смесь', 'строительная смесь'],
  'сухая смесь': ['строительная смесь', 'смесь'],
  'клей': ['клеевая смесь', 'монтажный клей'],

  // Дополнительные бренды
  'металл профиль': ['металлпрофиль', 'профнастил', 'металлопрофиль'],
  'руукки': ['ruukki', 'рукки'],
  'ruukki': ['руукки', 'рукки'],
};


// 🔤 Словарь фонетических соответствий: двусторонний EN ↔ RU
export const phoneticMap = {
  // EN → RU
  'line': 'лайн',
  'plus': 'плюс',
  'light': 'лайт',
  'premium': 'премиум',
  'eco': 'эко',
  'prof': 'проф',
  'professional': 'профессионал',
  'master': 'мастер',
  'standard': 'стандарт',
  'standart': 'стандарт',
  'classic': 'классик',
  'extreme': 'экстрим',
  'extra': 'экстра',
  'super': 'супер',
  'max': 'макс',
  'mini': 'мини',
  'optimal': 'оптимал',
  'comfort': 'комфорт',
  'smart': 'смарт',
  'grand': 'гранд',
  'royal': 'роял',
  'imperial': 'империал',
  'elite': 'элит',
  'prime': 'прайм',
  'top': 'топ',
  'base': 'база',
  'basic': 'базовый',
  'fix': 'фикс',
  'flex': 'флекс',
  'strong': 'стронг',
  'hard': 'хард',
  'soft': 'софт',
  'termo': 'термо',
  'thermo': 'термо',
  'aqua': 'аква',
  'hydro': 'гидро',
  'iso': 'изо',
  'techno': 'техно',
  'universal': 'универсал',
  'profi': 'профи',
  'original': 'оригинал',

  // Бренды и покрытия
  'satin': 'сатин',
  'matt': 'матт',
  'drap': 'драп',
  'norman': 'норман',
  'velur': 'велюр',
  'colority': 'колорити',
  'safari': 'сафари',
  'puretan': 'пуретан',
  'purex': 'пурекс',
  'cloudy': 'клауди',
  'velvet': 'вельвет',
  'purpro': 'пурпро',
  'pural': 'пурал',

  // Бренды материалов
  'vortex': 'вортекс',
  'foramina': 'форамина',
  'egger': 'эггер',
  'kronospan': 'кроноспан',
  'anderep': 'андереп',
  'rockwool': 'роквул',
  'technonicol': 'технониколь',
  'knauf': 'кнауф',
  'penoplex': 'пеноплекс',
  'isover': 'изовер',
  'onduline': 'ондулин',
  'shinglas': 'шинглас',
  'wenge': 'венге',
  'skandik': 'скандик',
  'batts': 'баттс',

  // RU → EN (обратный маппинг)
  'лайн': 'line',
  'плюс': 'plus',
  'лайт': 'light',
  'премиум': 'premium',
  'эко': 'eco',
  'проф': 'prof',
  'профессионал': 'professional',
  'мастер': 'master',
  'стандарт': 'standard',
  'классик': 'classic',
  'экстрим': 'extreme',
  'экстра': 'extra',
  'супер': 'super',
  'макс': 'max',
  'мини': 'mini',
  'оптимал': 'optimal',
  'комфорт': 'comfort',
  'смарт': 'smart',
  'гранд': 'grand',
  'роял': 'royal',
  'империал': 'imperial',
  'элит': 'elite',
  'прайм': 'prime',
  'топ': 'top',
  'база': 'base',
  'базовый': 'basic',
  'фикс': 'fix',
  'флекс': 'flex',
  'стронг': 'strong',
  'хард': 'hard',
  'софт': 'soft',
  'термо': 'thermo',
  'аква': 'aqua',
  'гидро': 'hydro',
  'изо': 'iso',
  'техно': 'techno',
  'универсал': 'universal',
  'профи': 'profi',
  'оригинал': 'original',

  // Бренды и покрытия (обратный маппинг)
  'сатин': 'satin',
  'матт': 'matt',
  'драп': 'drap',
  'норман': 'norman',
  'велюр': 'velur',
  'колорити': 'colority',
  'сафари': 'safari',
  'пуретан': 'puretan',
  'пурекс': 'purex',
  'клауди': 'cloudy',
  'вельвет': 'velvet',
  'пурпро': 'purpro',
  'пурал': 'pural',

  // Бренды материалов (обратный маппинг)
  'вортекс': 'vortex',
  'форамина': 'foramina',
  'эггер': 'egger',
  'кроноспан': 'kronospan',
  'андереп': 'anderep',
  'роквул': 'rockwool',
  'технониколь': 'technonicol',
  'кнауф': 'knauf',
  'пеноплекс': 'penoplex',
  'изовер': 'isover',
  'ондулин': 'onduline',
  'шинглас': 'shinglas',
  'венге': 'wenge',
  'скандик': 'skandik',
  'баттс': 'batts',
};
